// extracted by mini-css-extract-plugin
export default {"stand":"Stand_stand__4L3ov","inputs":"Stand_inputs__KtoAT","buttons":"Stand_buttons__Oj639","checkboxes":"Stand_checkboxes__aw2jC"};